import React, { useState, useRef } from "react";
import { FaFileExport, FaFileExcel, FaFilePdf, FaChevronDown } from "react-icons/fa";
import "./ExportMenu.css";

// A single "Export" button. Hover (or click) reveals Excel / PDF below it.
// Reused across the dSlip pages so every export control looks the same.
export default function ExportMenu({ onExcel, onPdf, disabled, label = "Export", align = "right" }) {
    const [open, setOpen] = useState(false);
    const timer = useRef(null);

    const openNow = () => { clearTimeout(timer.current); if (!disabled) setOpen(true); };
    const closeSoon = () => { timer.current = setTimeout(() => setOpen(false), 140); };
    const pick = (fn) => { setOpen(false); fn && fn(); };

    return (
        <div className="xmenu" onMouseEnter={openNow} onMouseLeave={closeSoon}>
            <button
                type="button"
                className="xmenu-btn"
                disabled={disabled}
                onClick={() => !disabled && setOpen((o) => !o)}
                aria-haspopup="menu"
                aria-expanded={open}
            >
                <FaFileExport /> {label} <FaChevronDown className={`xmenu-caret ${open ? "up" : ""}`} />
            </button>
            {open && !disabled && (
                <div className={`xmenu-pop xmenu-pop--${align}`} role="menu">
                    <button type="button" className="xmenu-item xmenu-excel" role="menuitem" onClick={() => pick(onExcel)}>
                        <FaFileExcel /> Excel
                    </button>
                    <button type="button" className="xmenu-item xmenu-pdf" role="menuitem" onClick={() => pick(onPdf)}>
                        <FaFilePdf /> PDF
                    </button>
                </div>
            )}
        </div>
    );
}
